// tslint:disable-next-line:import-name
import React, { ReactNode, Fragment } from 'react';
import { UniqMotorcycle } from '../api/dmdcuData';
import { DmdcuDataContext } from '../api/dmdcuDataContext';

import { formatTimeShort, formatDateShort } from '../tools/tools';

import Swiper from 'swiper';

export interface IAssetDetailsUIProps {
  motorcycle: UniqMotorcycle;
  dataContext: DmdcuDataContext;
}

// enum AssetDetailsUILoadingState {
//   Unintialized,
//   Loading, // it's about to load data from the blockchain
//   Loaded, // the data is loaded, but not processed in the UI yet.
//   Ready, // the data is processed in the UI as well, everything is ready.
//   LoadFailed, // loading failed because of an error.
// }

// class AssetDetailsUIState {

//   public loadingState: AssetDetailsUILoadingState = AssetDetailsUILoadingState.Unintialized;
// }


export default class AssetDetailsUI extends React.Component<IAssetDetailsUIProps> {
  // constructor(props: IAssetDetailsUIProps) {
  //   super(props);
  // }

  // public setLoadingState(state: AssetDetailsUILoadingState) {
  //   this.setState((s ,p ) => ({
  //     loadingState: state,
  //   }));
  // }

  render() : ReactNode {

    const moto = this.props.motorcycle!;

    const lastUpdatedDateFormated = formatDateShort(moto.changeDate);
    const lastUpdatedTimeFormated = formatTimeShort(moto.changeDate);


    // IMAGES

    let imageSection: ReactNode;

    const additionalImages = [ this.props.dataContext.api.web3.utils.toUtf8(moto.imageRessourcesIPFSAddress) ];
    additionalImages.push( ...moto.getAdditionalImages());

    if (additionalImages.length > 1) {

      const imageDivs = additionalImages.map((i) => {
        return <div key={i} className="swiper-slide" style={{ backgroundImage: `url(assets/${i}.jpg)`,}} />});

      imageSection = <div className="itemDetailPhoto"><div className="swiper-container gallery-top">
        <div className="swiper-wrapper">
          {imageDivs}
        </div>

        <div className="swiper-button-next swiper-button-white"></div>
        <div className="swiper-button-prev swiper-button-white"></div>
      </div>
      <div className="swiper-container gallery-thumbs">
        <div className="swiper-wrapper">
          {imageDivs}
        </div>
      </div>
      </div>;
    } else {
      imageSection = <div className="itemDetailPhoto">
      <div  style={{ backgroundImage: `url(assets/${this.props.dataContext.api.web3.utils.toUtf8(moto.imageRessourcesIPFSAddress)}.jpg)`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        width: '100%',
        height: '100%',
      }} />
    </div>;
    }

    // DOCUMENTS

    const documentsRaw = moto.getDocuments();
    let documents;
    if (documentsRaw.length > 0) {
      documents = <div className="documents">
      <h3>Documents</h3>
      <div className="documentsList">
        <ul>
          {documentsRaw.map((d) => {return <li><a href={`assets/documents/${d.documentLocation}`} target="_blank" rel="noopener noreferrer" title="">{`${d.uploadDate.toLocaleDateString()} : ${d.documentLocation}`}</a></li>})}
        </ul>
      </div>
   </div>
    }

    return <section className="asset-detail">
    <div className="sectionInner">

      <h1>{moto.name}</h1>
      {/* <div className="modificationButton">
        <a href="new-asset.html" title="Add new modification" className="addModification">Add new Modification</a>
        <a href="#" title="Download QR-Code as PDF" className="downloadQR">QR-Code</a>
      </div> */}
      <div className="clear"></div>
      <p className="lastUpdate">Last updated:  <strong>{lastUpdatedDateFormated}</strong> at <strong>{lastUpdatedTimeFormated}</strong> by <strong>{moto.certifier.certifierName}</strong></p>

      <div className="certiefiedItemDetail">
        {imageSection}
        <div className="itemDetailInfos">
          <h2>Detailed Informations</h2>
          <div className="numbers">
            <div className="numbersItem">
              <span className="label">Name Customized: </span>
              <span className="value">{moto.name}</span>
            </div>
            <div className="numbersItem">
              <span className="label">Model Base Name: </span>
              <span className="value">{moto.name2}</span>
            </div>

            <div className="numbersItem half">
              <span className="label">PS/KW: </span>
              <span className="value">{`${moto.horsepower}/${moto.horsePowerAsKw()}`}</span>
            </div>
            <div className="numbersItem half">
              <span className="label">Top speed: </span>
              <span className="value">{`${moto.topSpeed} km/h`}</span>
            </div>
            <div className="numbersItem half">
              <span className="label">Original build date: </span>
              <span className="value">{moto.buildDateFormatted()}</span>
            </div>
            <div className="numbersItem half">
              <span className="label">First customization: </span>
              <span className="value">{moto.changeDateFormatted()}</span>
            </div>
            <div className="numbersItem half">
              <span className="label">Last customization: </span>
              <span className="value">{moto.changeDateFormatted()}</span>
            </div>
            <div className="numbersItem half">
              <span className="label">Customization grade: </span>
              <span className="value">{moto.customizationGradeAsText()}</span>
            </div>
            <div className="numbersItem half">
              <span className="label">Vintage rating: </span>
              <span className="value">{moto.vintageGrade}</span>
            </div>
            <div className="numbersItem half">
              <span className="label">High-Tech rating: </span>
              <span className="value">{moto.techGrade}</span>
            </div>
          </div>


          <div className="description">
            <h3>Description</h3>
            <p className="shortdesc">{moto.assetPlainText}</p>
            <div className="longdesc">
              {moto.getLongText()}
            </div>
          </div>

          {documents}
{/* 
          <div className="uniqueidentifier">
            <h3>Unique Identifier</h3>
            <p><a href="#">0xc59b04e592408fe2fffab211f3e2408fe1fadfa629a18e06bbdb952a7159cf26</a></p>
          </div> */}




        </div>
        <div className="clear"></div>

        <div className="history">
          <h2>Previous Modifications</h2>
          <div className="modificationsList">

            <p className="modificationItem headline">
              <span className="nr">#</span>
              <span className="date">Date / Time</span>
              <span className="certifier">Certifier</span>
              <span className="shortdesc">Short Description</span>
              <span className="details">Details</span>
            </p>

            {moto.getHistoryEntries().sort((a, b) => { return b.number - a.number; }).map((h) => {
              return <p className="modificationItem">
                <span className="nr">{h.number} </span>
                <span className="date">{`${h.historyEntryDate.toLocaleDateString()} at  ${h.historyEntryDate.toLocaleTimeString()}`}</span>
                <span className="certifier valid">{h.certifier}</span>
                <span className="shortdesc">{h.text}</span>
                <span className="details"></span>
              </p>;
            })}
          </div>
        </div>
    </div>
  </div>
  </section>;
  }

  componentDidMount() {

    const galleryThumbs = new Swiper('.gallery-thumbs', {
      spaceBetween: 10,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });

    const galleryTop = new Swiper('.gallery-top', {
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
  
  }

}
